<div class="dialog-letter">

  <div class="card-div">
    <mat-dialog-content class="mat-typography">
      <h1 mat-dialog-title><app-brand-mark [size]="56"></app-brand-mark> {{ 'common.welcome' | t }}</h1>

      <div>
        <!-- <div class="alert alert-info">
        <img [src]="logo" width="50" height="50" [alt]="logo" />
      </div> -->
      <div class="card">
        <h1 class="card-header">{{ 'auth.signupTitle' | t }}</h1>
        <div class="card-body">
          @if (successInscription) {
            <div class="alert alert-success mb-0">
              {{ 'auth.signupSuccess' | t }}
            </div>
          }
          @if (!successInscription) {
            <form [formGroup]="inscriptionForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label style="display: flex;" for="email">{{ 'common.email' | t }}</label>
                <input type="email" formControlName="email" class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                  @if (submitted && f.email.errors) {
                    <div class="invalid-feedback">
                      @if (f.email.errors.required) {
                        <div>{{ 'common.emailRequired' | t }}</div>
                      }
                      @if (f.email.errors.email) {
                        <div>{{ 'common.emailInvalid' | t }}</div>
                      }
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label style="display: flex;" for="password">{{ 'common.password' | t }}</label>
                  <input type="password" formControlName="password" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    @if (submitted && f.password.errors?.required) {
                      <div class="invalid-feedback">
                        {{ 'common.passwordRequired' | t }}
                      </div>
                    }
                    @if (f.password.value) {
                      <div class="password-strength">
                        <div class="strength-bar-track">
                          <div class="strength-bar-fill" [ngClass]="strengthLevel"></div>
                        </div>
                        <span class="strength-label" [ngClass]="strengthLevel">
                          {{ 'password.strength' | t }}
                          <strong>{{ ('password.' + strengthLevel) | t }}</strong>
                        </span>
                      </div>
                    }
                    <ul class="password-rules">
                      <li [class.valid]="!f.password.errors?.minlength">{{ 'password.ruleLength' | t }}</li>
                      <li [class.valid]="!f.password.errors?.lowercase">{{ 'password.ruleLowercase' | t }}</li>
                      <li [class.valid]="!f.password.errors?.uppercase">{{ 'password.ruleUppercase' | t }}</li>
                      <li [class.valid]="!f.password.errors?.digit">{{ 'password.ruleDigit' | t }}</li>
                      <li [class.valid]="!f.password.errors?.specialChar">{{ 'password.ruleSpecial' | t }}</li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <label style="display: flex;" for="confirmPassword">{{ 'auth.confirmPassword' | t }}</label>
                    <input type="password" formControlName="confirmPassword" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && (f.confirmPassword.errors || inscriptionForm.errors?.passwordsMismatch) }" />
                      @if (submitted && f.confirmPassword.errors?.required) {
                        <div class="invalid-feedback">
                          {{ 'auth.confirmPasswordRequired' | t }}
                        </div>
                      }
                      @if (submitted && !f.confirmPassword.errors?.required && inscriptionForm.errors?.passwordsMismatch) {
                        <div class="invalid-feedback">
                          {{ 'common.passwordsMismatch' | t }}
                        </div>
                      }
                    </div>
                    <div class="form-group consents" style="display: flex; flex-direction: column; gap: 8px;">
                      <mat-slide-toggle formControlName="newsletter" id="signupNewsletter"><span>{{ 'consents.newsletter' | t }}</span></mat-slide-toggle>
                      <mat-slide-toggle formControlName="partnerOffers" id="signupPartnerOffers"><span>{{ 'consents.partnerOffers' | t }}</span></mat-slide-toggle>
                      <small class="consents-hint" style="opacity: 0.8;">{{ 'consents.signupHint' | t }}</small>
                    </div>
                    <button [disabled]="loading" class="btn btn-primary" cdkFocusInitial>
                      @if (loading) {
                        <span class="spinner-border spinner-border-sm mr-1"></span>
                      }
                      {{ 'auth.createAccount' | t }}
                    </button>
                    @if (error) {
                      <div class="alert alert-danger mt-3 mb-0">{{error}}</div>
                    }
                  </form>
                }
              </div>
            </div>
          </div>
          <br>
            <p>{{ 'common.privacyAck' | t }} <a class="verySmallText" routerLink="privacyPolicy">{{ 'common.privacyPolicyLink' | t }}</a></p>
            <br>
              <button color="primary" (click)="openDialogLogin()" [mat-dialog-close]="true" mat-stroked-button>
                {{ 'auth.alreadyHaveAccount' | t }}
              </button>
            </mat-dialog-content>

          </div>
          <!-- <div class="card-div">
          <mat-dialog-content class="mat-typography">
            <h1 mat-dialog-title>Inscription</h1>

            <div>
              <div class="alert alert-info">
                email: test<br />
                Password: test
              </div>
              <div class="card">
                <h4 class="card-header">Angular 10 Basic Authentication Example</h4>
                <div class="card-body">
                  <form [formGroup]="insriptionForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                      <label for="email">email</label>
                      <input type="text" formControlName="email" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                          <div *ngIf="f.email.errors.required">email is required</div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" formControlName="password" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                          </div>
                        </div>
                        <button [disabled]="loading" class="btn btn-primary">
                          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                          Login
                        </button>
                        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                      </form>
                    </div>
                  </div>
                </div>




                <mat-slide-toggle><span>J'accepte de recevoir la newsletter de promodeep.com</span></mat-slide-toggle>
                <mat-slide-toggle><span>J'accepte de recevoir des publicités de nos partenaires</span></mat-slide-toggle>


                <br>
                  <br>
                    <p>Vous affirmez pris connaissance de notre <a class="verySmallText" routerLink="privacyPolicy">Politique de
                    confidentialité.</a></p>
                    <br>
                      <h5>

                      </h5>
                    </mat-dialog-content>
                    <mat-dialog-actions align="end">

                    </mat-dialog-actions>
                  </div> -->
                </div>
